import { Injectable } from '@angular/core';
import { IModal } from '@domain/business-layer';
import { ModalController } from '@ionic/angular';
import { getMaxBreakpoint, PlatformProvider } from '@shared';
import { from, Observable, switchMap, take, tap } from 'rxjs';
import { ConnectionsModalComponent } from '../components';
import { ConnectionTypeEnum } from '../models';

@Injectable()
export class ConnectionsManagerService {
	public constructor(
		private modalController: ModalController,
		private platformProvider: PlatformProvider
	) {}

	public open(connectionType: ConnectionTypeEnum): Observable<IModal> {
		return from(
			this.modalController.create({
				component: ConnectionsModalComponent,
				cssClass: 'custom-searcheable-select',
				id: 'connections-manager',
				backdropDismiss: true,
				initialBreakpoint: getMaxBreakpoint(this.platformProvider.getPlatform()),
				showBackdrop: false,
				componentProps: {
					connectionType
				}
			})
		).pipe(
			take(1),
			tap(async (modal) => await modal.present()),
			switchMap(async (modal) => await modal.onDidDismiss<string>())
		) as Observable<IModal>;
	}
}
